import { render, staticRenderFns } from "./IntroScreen.vue?vue&type=template&id=0fd8dfbc&scoped=true&"
import script from "./IntroScreen.vue?vue&type=script&lang=js&"
export * from "./IntroScreen.vue?vue&type=script&lang=js&"
import style0 from "./IntroScreen.vue?vue&type=style&index=0&id=0fd8dfbc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd8dfbc",
  null
  
)

export default component.exports